<template>
  <van-popup v-model="popShow" :close-on-click-overlay="false" position="bottom">
    <div ref="popupRef" class="verify_popup">
      <img :class="$store.state.isMirroring && 'mirror'" class="close" src="@/assets/close.png" @click="closePopup" />
      <div class="title">{{ title }}</div>
      <div v-if="account" class="account">{{ account }}</div>
      <div v-if="subtitle" class="sub_title">{{ subtitle }}</div>
      <div>
        <div class="input_title" :class="[$store.state.isMirroring && 'ta-r']">
          {{ isEmailVerify ? $t('common.emailCode') : $t('common.smsVerificationCode') }}
        </div>
        <CommonInput
          v-model="validCode"
          type="tel"
          inputmode="numeric"
          :placeholder="$t('accountSecurity.enterVerificationCode')"
          :class="[$store.state.isMirroring && 'mirror']"
          theme="white"
          :max-length="VALID_CODE_LENGTH"
          auto-focus
        >
          <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="sendCode">
            {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
          </div>
        </CommonInput>
      </div>
      <CommonBtn class="next_btn" :text="$t('common.next')" :disabled="!validCode" :on-click="handleNextPage" />
      <div v-if="showChangeTypeBtn" class="text_span" @click="changeType">
        {{ isEmailVerify ? $t('accountSecurity.smsVerification') : $t('paymentCode.emailVerification') }}
      </div>
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn.vue'
import { Toast } from 'vant'
import { maskEmail, maskPhoneNumber } from '@/utils'
import throttle from 'lodash/throttle'
import { isInWebView } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'

export default {
  name: 'AccountVerifyPopup',
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: { type: Boolean, required: true, default: false },
    isChangeEmail: { type: Boolean, default: true } // 是否修改手机
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      popShow: false,
      isEmailVerify: true, // 是否为邮箱验证
      validCode: '',
      phone: '',
      count: 59,
      msgValidating: false,
      firstSendMsg: true,
      userCountry: {
        countryFlagUrl: undefined,
        areaCode: undefined
      },
      title: this.$t('accountSecurity.changeEmail'),
      subtitle: ''
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        this.initTitle()
        this.initData()
        this.isEmailVerify = !!this.$store.state.userInfo.email
        if (this.isEmailVerify) {
          this.sendCode()
        }
        if (isInWebView()) {
          document.addEventListener('touchstart', this.checkInputFocus)
          this.checkInputFocus()
        }
      } else {
        if (isInWebView()) {
          document.removeEventListener('touchstart', this.checkInputFocus)
        }
      }
    },
    popShow(val) {
      this.$emit('input', val)
    },
    validCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.handleNextPage()
      }
    }
  },
  computed: {
    account() {
      if (this.isEmailVerify) {
        return maskEmail(this.$store.state.userInfo.email)
      } else {
        return maskPhoneNumber(this.$store.state.userInfo.phone)
      }
    },
    showChangeTypeBtn() {
      if (this.isEmailVerify && this.$store.state.userInfo.phone) {
        return true
      }
      if (!this.isEmailVerify && this.$store.state.userInfo.email) {
        return true
      }
      return false
    }
  },
  created() {
    this.getAreaCodes()
  },
  beforeMount() {
    this.initTitle()
  },
  methods: {
    checkInputFocus() {
      setTimeout(() => {
        if (document.activeElement.tagName === 'INPUT') {
          this.$refs.popupRef.style.paddingBottom = '35vh'
        } else {
          this.$refs.popupRef.style.paddingBottom = '0.24rem'
        }
      }, 200)
    },
    initData() {
      this.validCode = ''
      this.count = 59
      this.msgValidating = false
      this.firstSendMsg = true
      this.subtitle = ''
    },
    initTitle() {
      if (this.isChangeEmail) {
        if (this.$store.state.userInfo.email) {
          this.title = this.$t('accountSecurity.changeEmail')
          this.subtitle = ''
        } else {
          this.title = this.$t('accountSecurity.bindEmail')
          this.subtitle = this.$t('accountSecurity.phoneVerificationNote')
        }
      } else {
        if (this.$store.state.userInfo.phone) {
          this.title = this.$t('accountSecurity.changePhone')
          this.subtitle = ''
        } else {
          this.title = this.$t('accountSecurity.bindPhone')
          this.subtitle = ''
        }
      }
    },
    changeType() {
      this.isEmailVerify = !this.isEmailVerify
      this.initData()
      if (this.isEmailVerify) {
        this.sendCode()
      }
    },
    getAreaCodes() {
      const $this = this
      const countryNo = this.$store.state.userInfo.countryNo
      this.$http
        .get(window.serverPath + '/api/country/getAreaCodes', { cache: true })
        .then(function (res) {
          if (res.data && res.data.code === '200' && res.data.data) {
            res.data.data.forEach((each) => {
              if (each.countryNo === countryNo) {
                $this.userCountry = each
              }
            })
          }
        })
        .catch((_err) => {
          console.log('err')
        })
    },
    async sendCode() {
      try {
        if (this.msgValidating) {
          return
        }
        let url = ''
        let params = {}

        if (this.isEmailVerify) {
          url = window.serverPath + '/api/auth/getNewEmailCode/CHANGE_BINDING_ACCOUNT'
          params = { email: this.$store.state.userInfo.email }
        } else {
          url = window.serverPath + '/api/auth/getNewSmsCode/CHANGE_BINDING_ACCOUNT'
          params = {
            phone: this.$store.state.userInfo.phone,
            userId: this.$store.state.userInfo.userId,
            areaCode: this.userCountry.areaCode
          }
        }

        const { data } = await this.$http.post(url, params)

        if (data.code === '200') {
          this.msgValidating = true
          this.firstSendMsg = false
          this.showSendSuccessToast(data.data === 'WhatsApp')
          const interval = window.setInterval(() => {
            this.count -= 1
            if (this.count <= 0) {
              clearInterval(interval)
              this.msgValidating = false
              this.count = 59
            }
          }, 1000)
        } else if (data.code === '60001' && this.isEmailVerify) {
          Toast({
            message: this.$t('loginAndRegister.userExistToast')
          })
          this.msgValidating = false
          this.count = 59
        } else {
          Toast({
            message: data.message
          })
          this.msgValidating = false
          this.count = 59
        }
      } catch (err) {
        console.log('异常')
        this.msgValidating = false
        this.count = 59
      }
    },
    showSendSuccessToast(toWhatsapp) {
      const msg = this.isEmailVerify
        ? this.$t('redesign.sendToEmail')
        : toWhatsapp
          ? this.$t('redesign.sendToWhatsapp')
          : this.$t('redesign.sendToPhone')
      Toast({
        message: msg
      })
    },
    handleNextPage: throttle(
      function () {
        const params = {}
        if (this.isEmailVerify) {
          params.email = this.$store.state.userInfo.email
        } else {
          params.phone = this.$store.state.userInfo.phone
        }
        params.validCode = this.validCode
        this.$http
          .post(window.serverPath + '/api/auth/checkVerification/CHANGE_BINDING_ACCOUNT', params)
          .then((res) => {
            if (res.data.code === '200' && res.data.data) {
              const apiParams = {
                oldEmail: params.email,
                oldPhone: params.phone,
                areaCode: this.userCountry.areaCode,
                code: params.validCode
              }
              const editType = this.getEditType()
              this.$emit('openAccountEditPopup', {
                editType,
                apiParams
              })
              this.$store.commit('setSecurityToken', res.data.data.securityToken)
              this.closePopup()
            } else {
              console.log('失败')
              Toast({
                message: this.$t('accountSecurity.wrongCodeToast')
              })
            }
          })
          .catch((_err) => {
            console.log('异常')
          })
      },
      5000,
      { trailing: false }
    ),
    getEditType() {
      if (this.isChangeEmail) {
        return this.$store.state.userInfo.email ? 'change' : 'bind'
      } else {
        return this.$store.state.userInfo.phone ? 'change' : 'bind'
      }
    },
    // 关闭并清空状态
    closePopup() {
      this.popShow = false
      this.initData()
    }
  }
}
</script>

<style scoped>
.verify_popup {
  /* height: 4rem; */
  padding: 0.24rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.title {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.04rem;
  max-width: calc(100% - 0.5rem);
  text-align: start;
}

.sub_title {
  display: flex;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}

.account {
  display: flex;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  direction: ltr;
}

.input_title {
  text-align: start;
  margin-top: 0.2rem;
  padding: 0.02rem 0.16rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
}

.text_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.next_btn {
  margin: 0.48rem auto 0;
  margin-bottom: 0.12rem;
  font-size: 0.16rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/VerifyPopup.vue